module App.Interfaces {
    export interface IDictionary {
        key: string;
        value: any;
    }
}